import React from 'react';
import { Link } from 'react-router';
import { Button, Container, Stack, Typography } from '@mui/material';
import PageSEO from '../../components/seo/PageSEO';
import { usePrerenderReady } from '../../hooks/usePrerenderReady';

/**
 * What logged-out visitors see at an address that isn't a page. It replaces the
 * old redirect to /login: since crawler routing went live (securspace-aws#20),
 * prerender followed that redirect and served a password form at any address
 * Google asked for, which is the pattern behind the "Deceptive pages" flag
 * (securspace-aws#50, securspace-ui#3057). No form here, and noindex.
 */
const NotFound = () => {
  // Nothing to fetch: let the crawler snapshot happen straight away.
  usePrerenderReady(true);
  return (
    <>
      <PageSEO
        title="Page not found | SecurSpace"
        description="This page doesn't exist. Find truck parking and container storage on SecurSpace."
        noindex
      />
      <Container maxWidth="sm" sx={{ py: 8, textAlign: 'center' }}>
        <Typography component="h1" variant="h4" gutterBottom>
          Page not found
        </Typography>
        <Typography color="textSecondary" sx={{ mb: 4 }}>
          This page doesn't exist or has moved.
        </Typography>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} justifyContent="center">
          <Button component={Link} to="/search" variant="contained">Find parking</Button>
          <Button component={Link} to="/" variant="outlined">Home</Button>
          <Button component={Link} to="/login" variant="text">Log in</Button>
        </Stack>
      </Container>
    </>
  );
};

export default NotFound;
